import { media } from "@src/theme"
import styled from "styled-components"

export const Row = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`

export const Icon = styled.img`
  width: 110px;
`

export const FooterText = styled.p`
  margin-top: 20px;
  font-size: 15px;
  line-height: 21px;
`

export const ButtonContainer = styled.div`
  width: 100%;
  max-width: 400px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  @media ${media.medium} {
    flex-direction: column};
  }
`

export const HeadingGray = styled.div`
  font-family: proxima-nova, sans-serif;
  font-size: 18px;
  color: #6f7379;
  text-align: center;
  width: 100%;
  font-weight: bold;
`

export const ResponsiveHeading = styled.div`
  @media ${media.medium} {
    margin-bottom: 20px;
  }
`
